var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.addData}},[_vm._v("Analytics"),_c('span',{staticClass:"badge badge-warning ml-1"},[_vm._v("BETA")])])
}
var staticRenderFns = []

export { render, staticRenderFns }